/**
 * One place to bind react-plotly.js to the bundled plotly build.
 *
 * The basic distribution carries the scatter trace and nothing else, which is
 * all Evaluwhale draws -- the full build triples the bundle for chart types
 * this application has no use for.
 */

import createPlotlyComponent from "react-plotly.js/factory";
import Plotly from "plotly.js-basic-dist-min";

const Plot = createPlotlyComponent(Plotly);

export const PLOT_CONFIG = {
  displaylogo: false,
  responsive: true,
  modeBarButtonsToRemove: ["lasso2d", "select2d", "autoScale2d"],
};

export const PLOT_FONT = {
  family:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  size: 12,
  color: "#1a1d21",
};

export default Plot;
